import { serverUtils } from '../utils/serverUtils/serverUtils';
import { CreditCardType } from './forms';

// eslint-disable-next-line no-control-regex
export const utf8Regex = /^[\u0000-\u007f]*$/;

export const textRegExp = '#:~:text=';

export const notEmptyString = /^(?!\s+$).*/;

export const notEmoji = /^(?:(?!\p{Extended_Pictographic}|$)[\s\S])*$/u;
// eslint-disable-next-line max-len
export const positive32IntRegexOrNothing = /^(\d|\d{1,9}|1\d{1,9}|20\d{8}|213\d{7}|2146\d{6}|21473\d{5}|214747\d{4}|2147482\d{3}|21474835\d{2}|214748364[0-7])*$/;

export const isSafari = !serverUtils.isServerSide()
&& navigator.vendor && navigator.vendor.indexOf('Apple') > -1
&& navigator.userAgent
&& navigator.userAgent.indexOf('CriOS') == -1
&& navigator.userAgent.indexOf('FxiOS') == -1;

export const postCodeRegexNetherlands = /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i;
export const postCodeRegexBelgium = /^[1-9]{1}[0-9]{3}$/;
export const postCodeRegexUnitedKingdom = /^[a-zA-Z]{1,2}[0-9][a-zA-Z0-9]? ?[0-9][a-zA-Z]{2}$/;
export const postCodeRegexGermany = /^(?!01000|99999)(0[1-9]\d{3}|[1-9]\d{4})$/;
// eslint-disable-next-line max-len
export const postCodeRegexFrance = /^\d{5}$/;
export const postCodeRegexItaly = /^\d{5}$/;
export const postCodeRegexIreland = /^[a-zA-Z][0-9]{2} ?[a-zA-Z0-9]{4}$/;
export const postCodeRegexAustria = /^[1-9]\d{3}$/;
export const postCodeRegexSpain = /^\d{5}/;
export const postCodeRegexPoland = /^[0-9]{2}-[0-9]{3}$/;
export const postCodeRegexNewZealand = /^[0-9]{4}$/;
export const postCodeRegexSweden = /^[0-9]{3} ?[0-9]{2}$/;
export const postCodeRegexMexico = /^\d{5}$/;
export const postCodeRegexDenmark = /^\d{4}/;
export const postCodeRegexNorway = /^\d{4}/;
export const postCodeRegexAustralia = /^(0[289]\d{2}|[2-8]\d{3}|9[0-7]\d{2})$/;
export const postCodeRegexCanada =
  /^[ABCEGHJ-NPRSTVXY][0-9][ABCEGHJ-NPRSTV-Z][ ]?[0-9][ABCEGHJ-NPRSTV-Z][0-9]$/;
export const postCodeRegexBrazil = /^\d{5}-?\d{3}$/;
export const postCodeRegexPortugal = /(^\d{4}-\d{3}?)(.*)/;
export const postCodeRegexSwitzerland = /^\d{4}/;
export const postCodeRegexUnitedArabEmirates = /^(?=.*\S).{1,20}$/;
export const postCodeRegexUSA = /^\d{5}(?:-\d{4})?$/;

export const phoneNumberRegex = /^([(]?[0-9]{3}[)]?)([-]*[0-9]){5,8}$/;

export const ABSOLUTE_URL_REGEX = /^(tel:|mailto:|https?:).+/;

const mastercardPart1 = /^5[1-5][0-9]{14}$/;
const mastercardPart2 = /^2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14})$/;
const mastercardPart3 = /^2(7[0-1][0-9]{13}|720[0-9]{12})$/;
const mastercard = new RegExp(
  `${mastercardPart1.source}|${mastercardPart2.source}|${mastercardPart3.source}`,
);

const maestroPart1 = /^(5018|5020|5038|5612)\d+$/;
const maestroPart2 = /^(5893|6304|6759|6761)\d+$/;
const maestroPart3 = /^(6762|6763|0604|6390)\d+$/;

const maestro = new RegExp(`${maestroPart1.source}|${maestroPart2.source}|${maestroPart3.source}`);

export const cardValidator: Record<CreditCardType, RegExp> = {
  [CreditCardType.ELECTRON]: /^(4026|417500|4405|4508|4844|4913|4917)\d+$/,
  [CreditCardType.MAESTRO]: maestro,
  [CreditCardType.DANKORT]: /^(5019)\d+$/,
  [CreditCardType.INTERPAYMENT]: /^(636)\d+$/,
  [CreditCardType.UNIONPAY]: /^(62|88)\d+$/,
  [CreditCardType.VISA]: /^4[0-9]{12}(?:[0-9]{3})?$/,
  [CreditCardType.MASTERCARD]: mastercard,
  [CreditCardType.AMERICAN_EXPRESS]: /^3[47][0-9]{13}$/,
  [CreditCardType.DINERS]: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
  [CreditCardType.DISCOVER]: /^6(?:011|5[0-9]{2})[0-9]{12}$/,
  [CreditCardType.JCB]: /^(?:2131|1800|35\d{3})\d{11}$/,
};
